<div class="container-fluid" id="container-wrapper" style="background-color: white;" *ngIf="userType=='Admin'">

    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Backup</h1>
    </div>

    <div style="margin: auto; padding: 20px; text-align: center; margin-top: 10px; margin-bottom: 10px; background-color: #f8f9fa; border-radius: 5px; border: 1px solid #dee2e6;">
        <button class="btn btn-info" (click)="startBackup()">Start Backup</button>
        <textarea id="resp" class="form-control" rows="20" readonly style="margin-top: 10px;"></textarea>
    </div>
</div>